import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';

@Component({
  selector: 'app-cinejoy-homepage',
  templateUrl: './cinejoy-homepage.component.html',
  styleUrls: ['./cinejoy-homepage.component.css']
})
export class CinejoyHomepageComponent implements OnInit {
  homepage:any
  mainImage: any;
  constructor(private router: Router, private service:AdminService) { }

  ngOnInit(): void {

    this.service.getCinejoyHomepage().subscribe(data=>{
      this.homepage = data.homePage
      this.mainImage = this.homepage.mainImage
    })
  }

  gotoSpotlight(): void {
    this.router.navigate([`premiere/upcoming`]);
  }

  gotoShowcase(): void {
    this.router.navigate([`showcase/`]);
  }

  gotoScreeningParties(): void {
    this.router.navigate([`screening-parties`]);
  }

  gotoTicketPasses(): void {
    this.router.navigate([`how-to`]);
  }

  gotoCelebration(): void {
    this.router.navigate([`celebrations/home`]);
  }

  getFileNameFromUrl(url: string): string {
    const filename = url.split('amazonaws.com/')[1];
    return 'https://d10ngl685yhldh.cloudfront.net/'+filename
  }

}

